import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './donate_button.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'
import { Button } from '@paypalcorp/pp-react'
import { trackClick } from '../../../../lib/fpti_analytics'
import { INSTRUMENT_EVENTS, INSTRUMENT_TAGS } from 'shared/shared_consts'

const i18n = getI18n('components/donate_button')
class DonateButton extends React.Component {
  static propTypes = {
    campaign: PropTypes.object,
    canChipIn: PropTypes.bool,
    canDonate: PropTypes.bool,
    createDNWTransaction: PropTypes.func,
    donateHref: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    endDate: PropTypes.instanceOf(Date),
    fullPageRefresh: PropTypes.bool,
    isDNWPayment: PropTypes.bool,
    isOwner: PropTypes.bool,
    noCurrencyBalance: PropTypes.bool,
    onClick: PropTypes.func,
    preview: PropTypes.bool,
    reversed: PropTypes.bool,
    secondary: PropTypes.bool,
    small: PropTypes.bool,
  }

  handleClick = e => {
    const { campaign, isDNWPayment, isOwner, noCurrencyBalance } = this.props
    const isNonOwnerWithDNWPayment = !isOwner && isDNWPayment
    if (noCurrencyBalance || isNonOwnerWithDNWPayment) {
      e.preventDefault()
    }
    trackClick({
      clickName: INSTRUMENT_TAGS.DONATE,
      data: {
        event_name: INSTRUMENT_EVENTS.DW_GIVING_DETAIL_DONATE_PRESSED,
        payment_type: isNonOwnerWithDNWPayment ? 'DNW' : 'P2P',
        charityname: campaign.charity && campaign.charity.name,
        crid: campaign.charity && campaign.charity.nonprofit_id,
      },
    })

    if (isNonOwnerWithDNWPayment) {
      this.props.createDNWTransaction({ campaignId: campaign.id })
    }
  }

  render() {
    if (this.props.preview) {
      return (
        <Button
          branded
          small={this.props.small}
          data-pa-click="donate"
          data-nemo="donate"
          styleName="donate-button preview"
        >
          {i18n('donate')}
        </Button>
      )
    } else if (!this.props.canDonate || !this.props.canChipIn) {
      return null
    } else {
      let linkProps = {}
      if (this.props.fullPageRefresh) {
        linkProps = { as: 'a', href: this.props.donateHref }
      } else {
        linkProps = { as: Link, to: this.props.donateHref }
      }

      return (
        <>
          <Button
            {...linkProps}
            branded
            secondary={this.props.secondary}
            inverse={this.props.reversed}
            small={this.props.small}
            data-nemo="donate"
            styleName="donate-button"
            onClick={this.handleClick}
          >
            {i18n('donate')}
          </Button>
          <div id="donate-button-cdn" />
        </>
      )
    }
  }
}

export default cssModules(DonateButton, styles, { allowMultiple: true })
